
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';
import {CurrencyGroup} from '../core/CurrencyGroup';
import {FieldModelCurrencyGroup} from '../core/CurrencyGroup';

/**
 * CurrencyGroupGetResponse struct
 */
class CurrencyGroupGetResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!CurrencyGroup=} currencyGroup
   * @constructor
   */
  constructor (parent = new Response(), currencyGroup = new CurrencyGroup()) {
    super()
    super.copy(parent)
    this.CurrencyGroup = currencyGroup
  }

  /**
   * Copy struct (shallow copy)
   * @this {!CurrencyGroupGetResponse}
   * @param {!CurrencyGroupGetResponse} other Other struct
   * @returns {!CurrencyGroupGetResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.CurrencyGroup != null) {
      this.CurrencyGroup = CurrencyGroup.fromObject(other.CurrencyGroup)
    } else {
      this.CurrencyGroup = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!CurrencyGroupGetResponse}
   * @returns {!CurrencyGroupGetResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new CurrencyGroupGetResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new CurrencyGroupGetResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!CurrencyGroupGetResponse}
   * @param {!CurrencyGroupGetResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof CurrencyGroupGetResponse)) {
      throw new TypeError('Instance of CurrencyGroupGetResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!CurrencyGroupGetResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      CurrencyGroup: ((this.CurrencyGroup != null) ? this.CurrencyGroup : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return CurrencyGroupGetResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!CurrencyGroupGetResponse} other Object value
   * @returns {!CurrencyGroupGetResponse} Created struct
   */
  static fromObject (other) {
    return new CurrencyGroupGetResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!CurrencyGroupGetResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return CurrencyGroupGetResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!CurrencyGroupGetResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 2005
  }
}

export { CurrencyGroupGetResponse };

/**
 * Fast Binary Encoding CurrencyGroupGetResponse field model
 */
class FieldModelCurrencyGroupGetResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.CurrencyGroup = new FieldModelCurrencyGroup(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelCurrencyGroupGetResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelCurrencyGroupGetResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelCurrencyGroupGetResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.CurrencyGroup.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelCurrencyGroupGetResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.CurrencyGroup.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelCurrencyGroupGetResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelCurrencyGroupGetResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelCurrencyGroupGetResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 2005
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelCurrencyGroupGetResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelCurrencyGroupGetResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.CurrencyGroup.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CurrencyGroup.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CurrencyGroup.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelCurrencyGroupGetResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelCurrencyGroupGetResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelCurrencyGroupGetResponse}
   * @param {!CurrencyGroupGetResponse} fbeValue Default value, defaults is new CurrencyGroupGetResponse()
   * @returns {!CurrencyGroupGetResponse} CurrencyGroupGetResponse value
   */
  get (fbeValue = new CurrencyGroupGetResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelCurrencyGroupGetResponse}
   * @param {!CurrencyGroupGetResponse} fbeValue CurrencyGroupGetResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.CurrencyGroup.fbeSize) <= fbeStructSize) {
      fbeValue.CurrencyGroup = this.CurrencyGroup.get()
    } else {
      fbeValue.CurrencyGroup = new CurrencyGroup()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CurrencyGroup.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelCurrencyGroupGetResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelCurrencyGroupGetResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelCurrencyGroupGetResponse}
   * @param {!CurrencyGroupGetResponse} fbeValue CurrencyGroupGetResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelCurrencyGroupGetResponse}
   * @param {CurrencyGroupGetResponse} fbeValue CurrencyGroupGetResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.CurrencyGroup.set(fbeValue.CurrencyGroup)
  }
}

export { FieldModelCurrencyGroupGetResponse };

/**
 * Fast Binary Encoding CurrencyGroupGetResponse model
 */
class CurrencyGroupGetResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelCurrencyGroupGetResponse(this.buffer, 4)
  }

  /**
   * Get the CurrencyGroupGetResponse model
   * @this {!CurrencyGroupGetResponseModel}
   * @returns {!FieldModelCurrencyGroupGetResponse} model CurrencyGroupGetResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!CurrencyGroupGetResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!CurrencyGroupGetResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return CurrencyGroupGetResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!CurrencyGroupGetResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelCurrencyGroupGetResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!CurrencyGroupGetResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!CurrencyGroupGetResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!CurrencyGroupGetResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!CurrencyGroupGetResponseModel}
   * @param {!CurrencyGroupGetResponse} value CurrencyGroupGetResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!CurrencyGroupGetResponseModel}
   * @param {!CurrencyGroupGetResponse} value CurrencyGroupGetResponse value, defaults is new CurrencyGroupGetResponse()
   * @return {!object} Deserialized CurrencyGroupGetResponse value and its size
   */
  deserialize (value = new CurrencyGroupGetResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new CurrencyGroupGetResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new CurrencyGroupGetResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!CurrencyGroupGetResponseModel}
   * @param {!number} prev Previous CurrencyGroupGetResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { CurrencyGroupGetResponseModel };
